import {NEXT_URL_SEARCH_PARAM_KEY} from '../../hooks/useNavigateToNextUrl';
import {linkToApp, linkToAppWithParams} from '../../url/linkToApp';
import Button from '../design_system/Button';
import {ButtonColor, ButtonSize} from '../design_system/Button/options';
import Flex from '../layout/flex/Flex';

import {css} from '@emotion/react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {createSearchParams} from 'react-router-dom';

export interface Props {
  readonly eventID: string;
}

export default function RegistrationFormMustSignup(props: Props): JSX.Element {
  const {eventID} = props;
  const {t} = useTranslation();
  const signupUrl = `${linkToApp('/signup')}?${createSearchParams({
    [NEXT_URL_SEARCH_PARAM_KEY]: linkToAppWithParams('/event/:id', {
      id: eventID,
    }),
  }).toString()}`;

  return (
    <Flex
      sx={css({
        width: '100%',
        height: 160,
        justifyContent: 'center',
      })}
    >
      <Button
        color={ButtonColor.ACCENT}
        label={t('components.event-registration-form.signup-cta-label')}
        size={ButtonSize.LARGE}
        to={signupUrl}
      />
    </Flex>
  );
}
